module.exports = __webpack_public_path__ + "static/media/failed.6966ed61.svg";